zpr-ml-uploading{
  zpr-ml-uploading-item{
    margin-bottom: 10px;
  }
  .progress-files-wrapper{
    overflow-y: hidden;
    height: 100%;
    margin-right: -18px;
    .progress-files{
      height: 100%;
      max-height: 320px;
      padding-right: 10px;
      transition: height 500ms ease-in ease-out;
      padding-bottom: 20px;
      overflow-y: auto;

      .uploading-row{
        height: 20px;
      }
      .progress-file{
        overflow: hidden;
        padding-right: 8px;
        p{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin:0;
          line-height: 14px;
        }
      }
      .progress-icon{
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        svg{
          width: 16px;
          height: 16px;
        }
      }
      .progress-file-icon{
        width: 20px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        svg{
          width: 20px;
        }
      }
      &::-webkit-scrollbar{
          width: 3px;
      }
      &::-webkit-scrollbar-track {
          background-color: color('silver');
          border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb {
          border-radius: 4px;
          background-color: color('ocean');
      }
    }
    .failed{
      color:color(danger-red);
    }
  }

}

@keyframes growProgressBar {
  0% { --value: 0; }
  10%, 100% { --value: var(--value); }
}

